import { AlertTriangle } from "lucide-react";
import { Link } from "react-router-dom";
import { useLang } from "@/i18n/LanguageContext";
import HtmlText from "@/components/HtmlText";
import FreshBadge from "@/components/FreshBadge";
import { articlePath } from "@/lib/radarPaths";

const sevClass = {
  Info: "severity-info",
  Event: "severity-event",
  Nomination: "severity-nomination",
  Indiscretion: "severity-indiscretion",
};

const AlertCard = ({ item, idx = 0, compact = false }) => {
  const { t, lang } = useLang();
  const to = articlePath("alerts", item);
  return (
    <article
      data-testid={`alert-card-${idx}`}
      className={`group bg-white border border-[#E5E7EB] hover:border-[#111827] transition-colors flex flex-col gap-2 ${compact ? "p-3" : "p-4"}`}
    >
      <div className="flex items-center gap-2 text-[10px] font-mono-dl uppercase tracking-wider">
        <span className={`px-1.5 py-0.5 ${sevClass[item.severity] || ""}`}>
          {t.severity[item.severity] || item.severity}
        </span>
        <span className="text-[#4B5563]">{item.alert_type}</span>
        <FreshBadge publishedAt={item.published_at} createdAt={item.created_at} lang={lang} />
        <span className="ml-auto text-[#9ca3af]">{item.published_at}</span>
      </div>
      <h3 className={`font-display ${compact ? "text-[15px]" : "text-[17px]"} leading-snug text-[#111827] flex items-start gap-1.5`}>
        <AlertTriangle size={14} className="mt-1 text-[#00A878] shrink-0" />
        <Link
          to={to}
          data-testid={`alert-title-${idx}`}
          className="group-hover:text-[#00A878] transition-colors"
        >
          {item.title}
        </Link>
      </h3>
      {!compact && <HtmlText html={item.description} className="text-[13px] text-[#4B5563] line-clamp-2" />}
      {item.dataleo_angle && !compact && (
        <div className="border-l-2 border-[#00A878] pl-3 mt-1">
          <div className="text-[10px] font-mono-dl tracking-wider uppercase text-[#00A878]">{t.labels.dataleoAngle}</div>
          <HtmlText html={item.dataleo_angle} className="text-[12px] text-[#111827] mt-0.5 line-clamp-2" />
        </div>
      )}
    </article>
  );
};

export default AlertCard;
